import {
  AttributionDetails,
  BroadbandSwitchDetails,
  ThankYouBasketFragment,
} from '@generated/gql/graphql';
import { SignupCheckoutEntity } from '@tracking/trackingEvents';
import { parseValueToPennies } from '@utils/price';

import { parseAttributionContext } from './parseAttributionContext';

const parseCheckoutEntity = (
  basket: ThankYouBasketFragment,
  attributionDetails: Nullable<AttributionDetails>,
  broadbandSwitchDetails: Nullable<BroadbandSwitchDetails>,
  hasJointAccountHolder: boolean,
  recentlyMovedIn: boolean
): SignupCheckoutEntity => {
  const attributionContext = parseAttributionContext(attributionDetails);

  return {
    actual_monthly_cost: parseValueToPennies(basket.monthlyCost?.value),
    joint_account_holder_added: hasJointAccountHolder,
    recent_move: recentlyMovedIn,
    cbc_holder_added: false,
    referrer_type: attributionContext.referrer_type,
    referrer_id: attributionContext.referrer_details,
    // TODO: decide what to do with existing_broadband_line
    existing_broadband_line: undefined,
    existing_broadband_provider_not_listed:
      broadbandSwitchDetails?.providerNotListed ?? undefined,
    existing_broadband_provider_shortcode:
      broadbandSwitchDetails?.losingProvider ?? undefined,
    ev_expression_of_interest:
      basket.energy?.details?.electricVehicleTariffExpressionOfInterest ??
      false,
    energy_usage_category: basket.energy?.details?.predefinedConsumption ?? '',
  };
};

export { parseCheckoutEntity };
